import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class ActivityTeachingAssignmentResponseDto {
  @ApiProperty({ type: 'string' })
  id!: string;

  @ApiProperty({ type: 'string' })
  activityId!: string;

  @ApiProperty({ type: 'string', format: 'uuid' })
  teachingId!: string;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  schoolYearCode!: string | null;

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  availableFrom!: string | Date | null;

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  dueAt!: string | Date | null;
}
